export default "__VITE_ASSET__D80ZwYLH__"